module.exports = __webpack_public_path__ + "static/media/landing-3.e9826a8d.jpg";